import React from 'react'
import { useTranslation } from 'react-i18next'

import InlineField from '../../../../components/Form/InlineField'
import Field from '../../../../components/Form/Field'

import { FREQUENCY_IMPRESSIONS, FREQUENCY_TIME_UNIT, timeUnitsList } from '../../fields'

import useStyles from './styles'

const FrequencyFields = ({ formik }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <div className={classes.frequencyFieldsWrapper}>
      {t('Limit to ')}
      <InlineField className={classes.frequencyField} formik={formik} name={FREQUENCY_IMPRESSIONS} type="number" />
      {t('exposures ')}
      <Field
        placeholder=""
        className={classes.timeUnitsSelect}
        formik={formik}
        name={FREQUENCY_TIME_UNIT}
        options={timeUnitsList}
      />
    </div>
  )
}

export default FrequencyFields
